var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb_svg-icon"},[_c('svg',{attrs:{"role":"img"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.iconId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }